module.exports = __webpack_public_path__ + "static/media/s_28.6ef4ee55.mp3";